/**
 * Preloads variant gallery images and switches the active image instantly on variant change.
 */
(function () {
  const cache = new Map();
  const prefetchedSections = new Set();

  function getData(sectionId) {
    const el = document.getElementById(`VariantMediaData-${sectionId}`);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function preloadImage(src) {
    if (!src || cache.has(src)) return cache.get(src);
    const promise = new Promise((resolve) => {
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = src;
    });
    cache.set(src, promise);
    return promise;
  }

  function preloadVariant(sectionId, variantId) {
    const data = getData(sectionId);
    const variant = data?.variants?.[String(variantId)];
    if (!variant?.src) return Promise.resolve(false);
    return preloadImage(variant.src);
  }

  function preloadAll(sectionId) {
    const data = getData(sectionId);
    if (!data?.variants) return;

    const urls = Object.values(data.variants)
      .map((v) => v.src)
      .filter(Boolean);

    const run = () => urls.forEach((url) => preloadImage(url));

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 2500 });
    } else {
      setTimeout(run, 300);
    }
  }

  function prefetchSection(sectionId, variantId) {
    const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
    if (!productInfo?.dataset.url) return;

    const key = `${sectionId}-${variantId}`;
    if (prefetchedSections.has(key)) return;
    prefetchedSections.add(key);

    const href = `${productInfo.dataset.url}?variant=${variantId}&section_id=${sectionId}`;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }

  function switchInstant(sectionId, variantId) {
    const data = getData(sectionId);
    const variant = data?.variants?.[String(variantId)];
    if (!variant) return;

    preloadVariant(sectionId, variantId);

    const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
    if (!gallery) return;

    const existing = gallery.querySelector(`[data-media-id="${variant.mediaId}"]`);
    if (existing && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(variant.mediaId, true);
    }

    const activeSlide =
      gallery.querySelector('.product__media-item.is-active') ||
      gallery.querySelector('.product__media-item');

    const img = activeSlide?.querySelector(
      '.product__media img.image-magnify-hover, .product__media img'
    );

    if (img && variant.src) {
      if (variant.srcset) img.srcset = variant.srcset;
      img.src = variant.src;
      if (variant.zoom) img.dataset.zoomSrc = variant.zoom;
      img.loading = 'eager';
      img.decode?.().catch(() => {});
    }

    if (typeof enableZoomOnHover === 'function') {
      requestAnimationFrame(() => enableZoomOnHover(2.5));
    }
  }

  window.VariantMediaPreload = {
    preloadAll,
    preloadVariant,
    prefetchSection,
    switchInstant,
  };

  function init() {
    document.querySelectorAll('[id^="VariantMediaData-"]').forEach((el) => {
      const sectionId = el.id.replace('VariantMediaData-', '');
      preloadAll(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
